import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@shared/component/base/base.component';
import { MatStepper } from '@angular/material/stepper';
import { Property, PropertyCollection, PropertyService } from 'taxtank-core';
import { PropertyValuationFormComponent } from '@client/shared/components/property/property-forms/property-valuation/property-valuation-form/property-valuation-form.component';
import CorelogicDialogComponent from '@shared/component/corelogic/corelogic-dialog.component';
import { PropertyAddFormComponent } from '@client/shared/components/property/property-forms/property-add/property-add-form/property-add-form.component';

/**
 * Property add form dialog. Combine Property, Address, PropertyForecast and PropertyShare form.
 * Save array of properties and forecasts, valuations, owners for each.
 */
@Component({
  selector: 'app-property-add-form-dialog',
  templateUrl: './property-add-form-dialog.component.html',
  styleUrls: ['./property-add-form-dialog.component.scss'],
  standalone: false,
})
export class PropertyAddFormDialogComponent extends BaseComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('propertyFormComponent') propertyFormComponent!: PropertyAddFormComponent;
  @ViewChild('valuationFormComponent', { static: false }) valuationFormComponent!: PropertyValuationFormComponent;
  property: Property;

  constructor(
    public dialogRef: MatDialogRef<PropertyAddFormDialogComponent>,
    public dialog: MatDialog,
    private propertyService: PropertyService) {
    super();
  }

  ngOnInit(): void {
    this.propertyService.get().subscribe((properties: PropertyCollection) => {
      if (!this.property) {
        return;
      }

      this.property = properties.findBy('id', this.property.id);
    });
  }

  submitForm(): void {
    [this.propertyFormComponent, this.valuationFormComponent][this.stepper.selectedIndex].submit();
  }

  onPropertyAdded(property: Property): void {
    this.property = property;
    this.stepper.next();
  }

  openCorelogicDialog(): void {
    this.dialog.open(CorelogicDialogComponent, {});
  }
}
